import React from "react"

import coverImage from "../../../images/coverImage.png"
import logo from "../../../images/logo-07.png"
import location from "../../../images/location.svg"

import "./detailpagebanner.scss"

export default function NewJobDetailPageBanner() {
  return (
    <div className="wdn-new wdn-job-banner  pb-20px">
      <div className="wjb-content ">
        <div className="cover-image">
          <img src={coverImage} alt="" className="img-fluid" />

          <div className="logo">
            <img src={logo} alt="" className="img-fluid" />
          </div>
        </div>

        <div className="mt-64px pb-16px px-36px">
          <div className="row">
            <div className="col-md-6">
              <h5 className=" text-md-start text-center">Software Engineer</h5>
              <div className="d-flex justify-content-center justify-content-md-start align-items-center gap-16px">
                <span>Smart Tech</span>
                <div className="location-box d-flex align-items-center gap-4px">
                  <span>
                    <img src={location} alt="" className="img-fluid" />
                  </span>
                  <span>Kathmandu Nepal</span>
                </div>
              </div>
            </div>
            <div className="col-md-6 text-md-end text-center">
              <div className="updated">
                <span>Posted 4 hours ago</span>
                <a href="#" className="btn btn-filled-v4">
                  Apply
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
